import { render, staticRenderFns } from "./ConventionBody.vue?vue&type=template&id=c81e13b8"
import script from "./ConventionBody.vue?vue&type=script&lang=js"
export * from "./ConventionBody.vue?vue&type=script&lang=js"
import style0 from "./ConventionBody.vue?vue&type=style&index=0&id=c81e13b8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports